import React from 'react';

const OperaIcon = () => {
  return (
    <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.49828 19.545C7.11578 17.9125 6.22078 15.5025 6.16078 12.795C6.16078 12.7875 6.16078 12.2125 6.16078 12.205C6.22078 9.4975 7.11578 7.0875 8.49828 5.455C10.2933 3.1275 12.9583 1.65 15.9333 1.65C17.7633 1.65 19.4783 2.21 20.9433 3.1825C18.7433 1.2125 15.8433 0.0125 12.6608 0C12.6458 0 12.6283 0 12.6133 0C5.71078 0 0.113281 5.5975 0.113281 12.5C0.113281 19.205 5.39078 24.675 12.0183 24.985C12.2158 24.995 12.4133 25 12.6133 25C15.8133 25 18.7333 23.7975 20.9433 21.82C19.4783 22.79 17.7658 23.35 15.9333 23.35C12.9583 23.35 10.2933 21.8725 8.49828 19.545Z"
        fill="url(#paint0_linear_2802_178)"
      />
      <path
        d="M8.49805 5.4549C9.64555 4.0999 11.1255 3.2849 12.7455 3.2849C16.3855 3.2849 19.333 7.4099 19.333 12.4999C19.333 17.5899 16.383 21.7149 12.7455 21.7149C11.128 21.7149 9.64555 20.8974 8.49805 19.5449C10.293 21.8724 12.958 23.3499 15.933 23.3499C17.763 23.3499 19.4781 22.7899 20.9431 21.8199C23.5031 19.5299 25.1131 16.2024 25.1131 12.4999C25.1131 8.7974 23.5031 5.4699 20.9431 3.1824C19.4781 2.2099 17.7655 1.6499 15.933 1.6499C12.958 1.6499 10.293 3.1274 8.49805 5.4549Z"
        fill="url(#paint1_linear_2802_178)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2802_178"
          x1="10.5289"
          y1="0.4076"
          x2="10.5289"
          y2="24.6361"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3" stopColor="#FF1B2D" />
          <stop offset="0.4381" stopColor="#FA1A2C" />
          <stop offset="0.5939" stopColor="#ED1528" />
          <stop offset="0.7581" stopColor="#D60E21" />
          <stop offset="0.9272" stopColor="#B70519" />
          <stop offset="1" stopColor="#A70014" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2802_178"
          x1="16.8058"
          y1="1.83554"
          x2="16.8058"
          y2="23.2645"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C0000" />
          <stop offset="0.7" stopColor="#FF4B4B" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default OperaIcon;